import { FormFieldTypes } from "../../../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../../../components/finalForms/libs/data/ValidationTypes";


const initState = {
  projectComponent: ''
}


export const ProjectComponentForm = {
  name: "Project Components Form",
  initialState: initState,
  section: [
    {
      title: "Project Component",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-2",
      },
      wrappperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "projectComponent",
          label: "Project Component",
          Field_Name: "project component",
          fieldType: FormFieldTypes.INPUT,
          dataField: "projectComponent",
          fieldSetting: {
            placeholder: "Please Enter Project Component",
            allowSpace: true,
            isDisable: false,
            maxLength: 50,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-md-12 validation-left-0",
          },
        },
      ]
    }
  ]
}

export default ProjectComponentForm;